import HelpTooltip from '@/app/common/components/HelpTooltip';
import { guideTooltipHtml } from './CoverageHelpTip';

const SITEMAP_IMPORT_GUIDE = {
  matchKey: 'sitemap-import',
  title: 'وارد کردن از نقشه سایت',
  paragraphs: [
    'این بخش آدرس‌ها را از sitemap.xml واکشی می‌کند تا بتوانید قبل از ارسال، موارد دلخواه را انتخاب کنید.',
    'اگر به هر دلیلی (sitemap در دسترس نبود، آدرس اشتباه، یا نبود URL در نقشه) آدرس‌های سایت شما پیدا نشد، پیشنهاد می‌کنیم همان آدرس‌ها را دستی در «لیست آدرس‌ها» وارد کنید.',
  ],
};

export function SitemapImportHelpTip() {
  return (
    <HelpTooltip
      html={guideTooltipHtml(SITEMAP_IMPORT_GUIDE)}
      placement="bottom"
      className="ms-1"
    />
  );
}
